import { formatMoney } from '@betterment/js-runtime';
import { Box, Heading, Text } from '@betterment/samba-react';
import { SambaAutoLink, numberRoundDownWithDecimals } from '@betterment/shared-components';

import { urlBuilder } from '../../../../../Shared/urlBuilder';
import { EmergencyFundSettingsPurpose } from '../../../data';

type Props = {
  purpose: EmergencyFundSettingsPurpose;
};

export const EmergencyFundTargetSection = ({ purpose }: Props) => {
  const { emergencyFundTarget: target, goalId, monthlyExpensesAmount } = purpose;
  const currentPath = window.location.pathname;
  const editUrl = urlBuilder.appGoalsEditPurpose.absolute({
    goal_id: goalId,
    skip_to_step: 'target',
    return_to: currentPath,
  });

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.200' }}>
      <Box css={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Heading variant="title100">Plan settings</Heading>
        <SambaAutoLink to={editUrl}>Edit</SambaAutoLink>
      </Box>
      <Box css={{ display: 'flex', flexDirection: 'column' }}>
        <Text variant="text50">Monthly expenses</Text>
        <Text>{formatMoney(monthlyExpensesAmount)}</Text>
      </Box>
      <Box css={{ display: 'flex', flexDirection: 'column' }}>
        <Text variant="text50">Target amount</Text>
        <Text>{target ? formatMoney(target.amount) : 'Not set'}</Text>
        {target && (
          <Text variant="text50" color="text.weak">
            {numberRoundDownWithDecimals(target.monthsExpensesCovered, 1)} months expenses
          </Text>
        )}
      </Box>
    </Box>
  );
};
